import ApiService from "@/base/api/api.service"

import {
    GET_LIKED_LIST
} from "@/store/actions.type"

import {
    PUSH_LIKED_USERS,
    SET_ERROR
} from "@/store/mutations.type"

import {
    GET_POST_URL
} from "@/base/api/config";

const StateKey = 'likedUsers'

export default {
    async [GET_LIKED_LIST]({ commit, state }, payload) {
        try {
            const res = await ApiService.get(GET_POST_URL,
                `${payload.postId}/likes?offset=${state[StateKey + 'Offset']}&limit=${state[StateKey + 'Limit']}`)
            commit(PUSH_LIKED_USERS, res.data.users)
        } catch (err) {
            commit(SET_ERROR, err.data)
        }
    }
}